import { render, staticRenderFns } from "./KiraSozlesmesiTahliyeTaahhuduAlacakForm.vue?vue&type=template&id=9d4d8340"
import script from "./KiraSozlesmesiTahliyeTaahhuduAlacakForm.vue?vue&type=script&lang=ts"
export * from "./KiraSozlesmesiTahliyeTaahhuduAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports